export default (initialState = {}) => {
  return () => {
    return {
      account_number: "",
      bank_beneficiary_name: "",
      ifsc_code: "",
      bank_name: "",
      code: "",
      file: null,
      is_primary: false,
      branch_address: "",
      ...initialState,
    };
  };
};
